import { useToast } from '@medely/ui-kit';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';

export type SchedulingPreferencesPayload = {
  labels: string[];
  workdays: string[];
  position_ids: number[];
  preferred_weekly_total_shifts: number;
};

export const useSchedulingPreferencesSubmit = (onSuccess: () => void) => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const toast = useToast();

  const { mutate: submitSchedulingPreferences, isPending: isSubmitting } = useMutation(
    (payload: SchedulingPreferencesPayload) =>
      axios.post('/v3/professional/scheduling_preferences', { preferences: payload }),
    {
      onSuccess: () => {
        toast.success('Scheduling preferences saved');
        queryClient.invalidateQueries({ queryKey: ['GetProfessionalSaasDetail'] });
        onSuccess();
      },
      onError: () => {
        toast.error('Failed to save scheduling preferences. Please try again.');
      },
    },
  );

  return { submitSchedulingPreferences, isSubmitting };
};
